export enum PRODUCT_AREAS {
    ADMIN = 'Admin',
    ADOPT = 'Adopt',
    ANALYTICS = 'Analytics',
    ASK_PENDO = 'AskPendo',
    FEEDBACK = 'Feedback',
    GROWTH = 'Growth',
    INSIGHTS = 'Insights',
    INTERNAL = 'Internal',
    METADATA = 'Metadata',
    ML = 'ML',
    MOBILE = 'Mobile',
    ORCHESTRATE = 'Orchestrate',
    ORGANIZATION = 'Organization',
    PLATFORM = 'Platform',
    PUBLIC = 'Public',
    SESSION_REPLAY = 'SessionReplay',
    SURVEYS = 'Surveys',
    TAGGING_AND_SETUP = 'TaggingAndSetup',
    VOC = 'Voc',
    IMPACT_BRIEF = 'ImpactBrief',
    // Guides product areas (from '@pendo/services/Constants')
    GUIDES = 'Guides',
    NPS = 'NPS',
    RESOURCE_CENTER = 'ResourceCenter',
    PREDICT = 'Predict'
}

export enum SUB_PRODUCT_AREAS {
    ADHOC_REPORTS = 'AdhocReports',
    ACCOUNT_LIST_DETAILS = 'AccountListAndDetails',
    ACCOUNT_METRICS_HOVER_CARD = 'AccountMetricsHoverCard',
    AGENT_MODE_MENTIONS = 'AgentModeMentions',
    AI_AGENTS = 'AiAgents',
    AI_ACCESS = 'AiAccess',
    ALERTS = 'Alerts',
    ANALYTICS = 'Analytics',
    APP_HEALTH = 'AppHealth',
    APPLICATION_SETTINGS = 'ApplicationSettings',
    APPLICATION_USAGE = 'ApplicationUsage',
    CAPTURE = 'Capture',
    DATA_EXPLORER = 'DataExplorer',
    DATA_SYNC = 'DataSync',
    EMAIL = 'Email',
    ERROR = 'Error',
    ESSENTIAL_CONTACTS = 'EssentialContacts',
    EXCLUDE_INCLUDE_LIST = 'ExcludeIncludeList',
    EXTENSION_SETTINGS = 'ExtensionSettings',
    FEATURE_LIST_DETAILS = 'FeatureListAndDetails',
    FUNNELS = 'Funnels',
    GENERAL = 'General',
    GOALS = 'Goals',
    HOMEPAGE = 'Homepage',
    INSIGHTS = 'Insights',
    INTEGRATIONS = 'Integrations',
    JOURNEYS = 'Journeys',
    JOURNEYS2 = 'Journeys2',
    LEO_HOVER_CARDS = 'LeoHoverCards',
    LIBRARY = 'Library',
    LICENSE_UTILIZATION = 'LicenseUtilization',
    MAU = 'MAU',
    METADATA = 'Metadata',
    ML = 'ML',
    ONBOARDING = 'Onboarding',
    ORCHESTRATE = 'Orchestrate',
    ORGANIZATION_DETAILS = 'OrganizationDetails',
    ORGANIZATION_SETTINGS = 'OrganizationSettings',
    PAGE_FEATURE_SETTINGS = 'PageAndFeatureSettings',
    PAGE_LIST_DETAILS = 'PageListAndDetails',
    PARTNER_SETTINGS = 'PartnerSettings',
    PATHS = 'Paths',
    PENDO_TOOLS = 'PendoTools',
    PER_WEEK_CHART_APPLICATION_USAGE = 'PerWeekChartApplicationUsage',
    PER_WEEK_CHART_ADOPTION = 'PerWeekChartAdoption',
    PER_WEEK_CHART_RETENTION = 'PerWeekChartRetention',
    PER_WEEK_CHART_EVENTS = 'PerWeekChartEvents',
    PER_WEEK_CHART_COUNTABLE = 'PerWeekChartCountable',
    PERMISSIONS = 'Permissions',
    PLAYER = 'Player',
    PORTFOLIO = 'Portfolio',
    PORTFOLIO_OVERVIEW = 'PortfolioOverview',
    PRODUCT_AREAS = 'ProductAreas',
    PRODUCT_ENGAGEMENT_SCORE = 'ProductEngagementScore',
    RESELLERS = 'Resellers',
    RETENTION = 'Retention',
    ROADMAPS = 'Roadmaps',
    SEGMENTS = 'Segments',
    SETTINGS = 'Settings',
    SETUP = 'Setup',
    SHARED = 'Shared',
    SSP = 'Self Serve Payment',
    STAGING = 'Staging',
    SUGGESTED_PAGES = 'SuggestedPages',
    TAG_HOVER_CARDS = 'TagHoverCards',
    TAG_MAINTENANCE = 'TagMaintenance',
    THEMES = 'Themes',
    TRACK_EVENT_LIST_DETAILS = 'TrackEventListAndDetails',
    TRENDS = 'Trends',
    UNTAGGED_URLS = 'UntaggedUrls',
    UPSELL = 'Upsell',
    USER_MANAGEMENT = 'UserManagement',
    USER_REGISTRATION = 'UserRegistration',
    VALIDATE = 'Validate',
    ACCOUNT_DETAILS = 'AccountDetails',
    PARENT_ACCOUNT_DETAILS = 'ParentAccountDetails',
    VISITOR_ACCOUNT_SEARCH = 'VisitorAccountSearch',
    VISITOR_LIST_DETAILS = 'VisitorListAndDetails',
    VISITOR_LIST_REPORT = 'VisitorListReport',
    ACCOUNT_LIST_REPORT = 'AccountListReport',
    PER_WEEK_CHART = 'PerWeekChart',
    PARENT_ACCOUNT_LIST_REPORT = 'ParentAccountListReport',
    VISITOR_METRICS_HOVER_CARD = 'VisitorMetricsHoverCard',
    WEB_ANALYTICS = 'WebAnalytics',
    WORKFLOWS = 'Workflows',
    // Dashboards sub product areas
    DASHBOARDS_APPLICATION_USAGE = 'DashboardsApplicationUsage',
    DASHBOARDS_BROWSER_USAGE = 'DashboardsBrowserUsage',
    DASHBOARDS_EVENTS = 'DashboardsEvents',
    DASHBOARDS_FEATURE_ADOPTION = 'DashboardsFeatureAdoption',
    DASHBOARDS_LICENSE_UTILIZATION = 'DashboardsLicenseUtilization',
    DASHBOARDS_METADATA_METRICS = 'DashboardsMetadataMetrics',
    DASHBOARDS_METADATA_VALUE = 'DashboardsMetadataValue',
    DASHBOARDS_PAGE_FEATURE_USE_OVER_TIME = 'DashboardsPageFeatureUseOverTime',
    DASHBOARDS_RETENTION = 'DashboardsRetention',
    DASHBOARDS_SCATTER_CHART = 'DashboardsScatterChart',
    DASHBOARDS_STICKINESS = 'DashboardsStickiness',
    DASHBOARDS_TAG_OVERVIEW = 'DashboardsTagOverview',
    DASHBOARDS_TIME_TO_FIRST_USE = 'DashboardsTimeToFirstUse',
    DASHBOARDS_TIMESPAN = 'DashboardsTimespan',
    DASHBOARDS_VISITOR_OVERVIEW = 'DashboardsVisitorOverview',
    // Guides sub product areas (from '@pendo/services/Constants')
    NPS_LIST = 'NPSList',
    NPS_POLLS = 'NPSPolls',
    NPS_RESULTS = 'NPSResults',
    NPS_THEMES = 'NPSThemes',
    NPS_UPSELL = 'NPSUpsell',
    NPS_WIZARD = 'NPSWizard',
    GUIDE_ORDERING = 'OrderingAndThrottlingTab',
    GUIDE_DETAILS = 'GuideDetails',
    GUIDE_DISPLAY_ALERTS = 'GuideDisplayAlerts',
    GUIDE_LIST = 'GuidesList',
    GUIDE_METRICS = 'GuideMetrics',
    GUIDE_UPSELL = 'GuideUpsell',
    GUIDE_EXPERIMENTS = 'GuideExperiments',
    POLLS = 'Polls',
    POLL_RESULTS = 'PollResults',
    RC_DETAILS = 'ResourceCenterDetails',
    RC_LIST = 'ResourceCenterList',
    RC_METRICS = 'ResourceCenterMetrics',
    RC_MODULE_DETAILS = 'ResourceCenterModuleDetails'
}
